import React from 'react'
import { Alert, Button, Form, Input, Typography } from 'antd'
import SpinLoader from '../../../helpers/SpinLoader'
import { TCallList } from '../../../../context/types'
import { useCallsListContext } from '../../../../context/call/CallsListProvider'
import { useAuthContext } from '../../../../context/auth'

const { TextArea } = Input
const { Title } = Typography

function Cancel({ call, onCancel }: { call: TCallList; onCancel: (isShowModal?: boolean) => void }) {
	const { callsList, actions } = useCallsListContext()
	const { auth } = useAuthContext()
	const [form] = Form.useForm()

	const onFinish = async (values: { change_reason: string }) => {
		await actions.cancel(call.id, values.change_reason)
		onCancel(auth?.user?.id === call?.user?.id)
	}

	return (
		<SpinLoader loading={!!callsList.loading}>
			<Form name="RescheduleForm" form={form} onFinish={onFinish} scrollToFirstError layout="vertical">
				<Title level={3}>Cancel</Title>
				<Alert
					showIcon
					message="Cancelled calls are subject to our cancellation policy."
					type="info"
					style={{ marginTop: 20 }}
				/>
				<Form.Item
					label="Cancel Reasons"
					name="change_reason"
					rules={[{ required: true, message: 'Please explain in detail your cancel reasons!' }]}
				>
					<TextArea placeholder="Please explain in detail your cancel reasons." autoSize={{ minRows: 4, maxRows: 8 }} />
				</Form.Item>
				<Form.Item>
					<div className="btn-actions">
						<Button shape="round" type="primary" htmlType="submit" disabled={!!callsList.loading}>
							Ok
						</Button>
						<Button shape="round" htmlType="button" disabled={!!callsList.loading} onClick={() => onCancel()}>
							Back
						</Button>
					</div>
				</Form.Item>
				{callsList.error && (
					<Alert showIcon message="Error" description={callsList.error} type="error" style={{ marginTop: 20 }} />
				)}
			</Form>
		</SpinLoader>
	)
}

export default Cancel
